import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { type RootState } from '@/store';

export const UserManagementTabType = {
  ACTIVE: 'ACTIVE',
  DEACTIVATED: 'DEACTIVATED'
} as const;

export type UserManagementTabTypeKeys = (typeof UserManagementTabType)[keyof typeof UserManagementTabType];

interface UserManagementState {
  activeUserManagementTab: UserManagementTabTypeKeys;
  usersListFinding: string;
  userEditId: string | null;
}

const initialState: UserManagementState = {
  activeUserManagementTab: UserManagementTabType.ACTIVE,
  usersListFinding: '',
  userEditId: null
};

const userManagementSlice = createSlice({
  name: 'userManagement',
  initialState: initialState,
  reducers: {
    setActiveUserManagementTab: (state, action: PayloadAction<UserManagementTabTypeKeys>) => {
      state.activeUserManagementTab = action.payload;
    },
    setUsersFinding: (state, action: PayloadAction<string>) => {
      state.usersListFinding = action.payload;
    },
    setUserEditId: (state, action: PayloadAction<string | null>) => {
      state.userEditId = action.payload;
    }
  }
});

export const { setActiveUserManagementTab, setUsersFinding, setUserEditId } = userManagementSlice.actions;

export const selectActiveUserManagementTab = (state: RootState) => {
  return state.userManagement.activeUserManagementTab;
};
export const selectUsersFinding = (state: RootState) => {
  return state.userManagement.usersListFinding;
};
export const selectUserEditId = (state: RootState) => {
  return state.userManagement.userEditId;
};

export const userManagementReducer = userManagementSlice.reducer;
